<template>
    <a :href="`/api/help_link/${link}`" target="_blank" style="text-decoration: none">
        <v-btn
            class="help-link"
            text
            color="primary"
        >
            <v-icon
                left
                size="18"
            >
                mdi-help-circle
            </v-icon>
            <span>{{ $t("Learn more") }}</span>
        </v-btn>
    </a>
</template>

<script>
export default {
    name: "HelpButton",
    props: {
        link: {
            type: String,
            required: true
        }
    }
}
</script>
